import React from "react";
import { router, Stack, useLocalSearchParams } from "expo-router";

import { HeaderX } from "~/components/HeaderElements";
import { SpaceForm } from "~/components/SpaceForm";

function SpaceFormPage() {
  const params = useLocalSearchParams<{
    spaceId: string;
  }>();

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: params.spaceId ? `Edit workspace` : `Create workspace`,
          headerRight: () => <HeaderX onPress={router.back} />,
        }}
      />
      <SpaceForm spaceId={params.spaceId} />
    </>
  );
}

export default SpaceFormPage;
